<template>
  <component :is="TypeComponent[customerSupportType]"></component>
</template>

<script setup>
import { CustomerSupportReportTypes } from "@/app/reports/utils/enums";

import Resume from "./Resume.vue";
import TimeSection from "./TimeSection.vue";
import DailyManagement from "./DailyManagement.vue";
import Abandoned from "./Abandoned.vue";
import UsersManagement from "./UsersManagement.vue";

const TypeComponent = {
  [CustomerSupportReportTypes.Resume]: Resume,
  [CustomerSupportReportTypes.TimeSection]: TimeSection,
  [CustomerSupportReportTypes.DailyManagement]: DailyManagement,
  [CustomerSupportReportTypes.Abandoned]: Abandoned,
  [CustomerSupportReportTypes.UsersManagement]: UsersManagement,
};

defineProps({
  customerSupportType: Number,
});
</script>

<style lang="sass" scoped></style>
